import * as Yup from 'yup';
import { SarlaftStrategicAlly } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftStrategicAlly & {
    strategicAllyLabel?: string;
} = {
    strategicAlly: '',
    strategicAllyLabel: '',
};

export const validationSchema = Yup.object({
    strategicAlly: Yup.string().required(
        'El aliado estratégico es obligatorio'
    ),
});
